module.exports = {
  communitySolo: {
    vi: {
      title: 'Tìm người chơi Avalon online · Avalon',
      description:
        'Tìm người chơi Avalon cùng ngôn ngữ. So sánh kinh nghiệm và sở thích trò chuyện bằng giọng nói hoặc văn bản, rồi liên hệ qua Discord, Telegram, LINE, QQ hoặc WeChat.',
      keywords: ['Avalon'],
    },
    en: {
      title: 'Find Avalon players online · Avalon',
      description:
        'Find Avalon players in your language. Compare experience and voice or text preferences, then contact them on Discord, Telegram, LINE, QQ or WeChat.',
      keywords: ['Avalon'],
    },
    ru: {
      title: 'Найти игроков для Авалона онлайн · Avalon',
      description:
        'Найдите игроков для Авалона на своём языке. Сравните опыт и формат общения, свяжитесь через Discord, Telegram, LINE, QQ или WeChat.',
      keywords: ['Avalon'],
    },
    es: {
      title: 'Encuentra jugadores de Avalon online · Avalon',
      description:
        'Encuentra jugadores de Avalon en tu idioma. Compara experiencia y preferencias de voz o texto y contacta por Discord, Telegram, LINE, QQ o WeChat.',
      keywords: ['Avalon'],
    },
    pt: {
      title: 'Encontre jogadores de Avalon online · Avalon',
      description:
        'Encontre jogadores de Avalon no seu idioma. Compare experiência e preferências de voz ou texto e fale pelo Discord, Telegram, LINE, QQ ou WeChat.',
      keywords: ['Avalon'],
    },
    'zh-CN': {
      title: '寻找阿瓦隆线上玩家 · Avalon',
      description: '按语言寻找阿瓦隆玩家，比较经验和语音或文字偏好，通过 Discord、Telegram、LINE、QQ 或微信联系对方。',
      keywords: ['Avalon'],
    },
    'zh-TW': {
      title: '尋找阿瓦隆線上玩家 · Avalon',
      description: '依語言尋找阿瓦隆玩家，比較經驗與語音或文字偏好，透過 Discord、Telegram、LINE、QQ 或微信聯絡對方。',
      keywords: ['Avalon'],
    },
  },
  communityGroup: {
    vi: {
      title: 'Tìm Đội chơi Avalon online · Avalon',
      description:
        'Tìm Đội chơi Avalon cùng ngôn ngữ. So sánh lịch chơi, chọn Đội chào đón người mới rồi liên hệ người tổ chức hoặc mở lời mời vào nhóm.',
      keywords: ['Avalon'],
    },
    en: {
      title: 'Find an Avalon team online · Avalon',
      description:
        'Find an Avalon team in your language. Compare schedules, choose teams that welcome beginners, and contact the organizer or open a group invitation.',
      keywords: ['Avalon'],
    },
    ru: {
      title: 'Найти команду для Авалона онлайн · Avalon',
      description:
        'Найдите команду для Авалона на своём языке. Сравните расписания, выберите команду, где рады новичкам, свяжитесь с организатором или откройте приглашение.',
      keywords: ['Avalon'],
    },
    es: {
      title: 'Encuentra un equipo de Avalon online · Avalon',
      description:
        'Encuentra un equipo de Avalon en tu idioma. Compara horarios, busca equipos que acepten principiantes y contacta con el organizador o abre una invitación.',
      keywords: ['Avalon'],
    },
    pt: {
      title: 'Encontre uma equipe de Avalon online · Avalon',
      description:
        'Encontre uma equipe de Avalon no seu idioma. Compare horários, escolha equipes que recebem iniciantes e fale com o organizador ou abra um convite.',
      keywords: ['Avalon'],
    },
    'zh-CN': {
      title: '寻找阿瓦隆线上队伍 · Avalon',
      description: '按语言寻找阿瓦隆队伍，比较时间安排，选择欢迎新手的队伍，联系组织者或打开群组邀请。',
      keywords: ['Avalon'],
    },
    'zh-TW': {
      title: '尋找阿瓦隆線上隊伍 · Avalon',
      description: '依語言尋找阿瓦隆隊伍，比較時間安排，選擇歡迎新手的隊伍，聯絡主辦人或開啟群組邀請。',
      keywords: ['Avalon'],
    },
  },
};
